
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/return",
      function () {
        return require("private-next-pages/return.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/return"])
      });
    }
  